module.exports = __webpack_public_path__ + "772da4377ffb7796209b03de1be29d29.svg";